import { getCustomPages, updateCustomPage, createCustomPage, deleteCustomPage, useQuery, useAction } from "wasp/client/operations";
import { useAuth } from "wasp/client/auth";
import type { CustomPageNavItem, CustomPagesActions } from "./NavBar";
import { trackCustomPageCreated, trackCustomPageDeleted } from '../../utils/posthog';

export function useCustomPages(): CustomPagesActions {
  const { data: user } = useAuth();
  const { data: pages = [], refetch } = useQuery(getCustomPages, undefined, { enabled: !!user });
  const update = useAction(updateCustomPage);
  const create = useAction(createCustomPage);
  const remove = useAction(deleteCustomPage);

  const items: CustomPageNavItem[] = (pages as any[]).map((page) => ({
    id: page.id,
    name: page.name,
    icon: page.icon,
    to: `/p/${page.id}`,
    onRename: async (newName: string) => {
      await update({ pageId: page.id, name: newName });
      refetch();
    },
    onChangeIcon: async (icon: string) => {
      await update({ pageId: page.id, icon });
      refetch();
    },
    onDelete: async () => {
      await remove({ pageId: page.id });
      trackCustomPageDeleted();
      refetch();
    },
  }));

  return {
    items,
    onCreatePage: async (name: string, icon: string) => {
      await create({ name, icon });
      trackCustomPageCreated();
      refetch();
    },
  };
}
